import { ITEM_CLICKED_DETAIL_EXPIRY_DURATION, ITEM_CLICKED_DATA } from './constants';
import { IS_SERVER } from './checkRenderEnv';

export function storeItemClickedDetails(itemId) {
  const expiresAt = new Date(new Date().getTime() + ITEM_CLICKED_DETAIL_EXPIRY_DURATION);
  const sessionObject = {
    expiresAt: expiresAt,
    itemId: itemId,
  };
  if (!IS_SERVER) {
    sessionStorage.setItem(ITEM_CLICKED_DATA, JSON.stringify(sessionObject));
  }
}
